export function getProgressPercent(done: number, all: number): number {
  return all === 0 ? 0 : Math.round((done / all) * 100);
}
